/** Returns a stored JWT only when it looks usable. */
export const getBearerToken = (): string | null => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  const trimmed = token.trim();
  if (!trimmed || trimmed === "null" || trimmed === "undefined") return null;
  return trimmed;
};

export const clearAuthToken = () => {
  localStorage.removeItem("token");
};
